import { OwnerPermissionsResponseDto } from '@/features/owners/types/owners-dto';

export type SidebarItem = {
    title: string;
    type: SidebarButtons;
    enabled: (type?: OwnerPermissionsResponseDto) => boolean;
    url: string;
    icon?: React.FC<React.SVGProps<SVGSVGElement>>;
    activeIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
    items?: {
        title: string;
        url: string;
    }
}

export type SidebarList = {    
    title?: string;
    items?: SidebarItem[];
};

export type SidebarElement = {
    [key: string]: SidebarList;
};

export enum SidebarButtons {
    Dashboard, 
    Apartments, 
    Calendar, 
    Finances, 
    Orders, 
    Faq, 
    Owners, 
    Notifications, 
    NewsOffers, 
    Settings,
    Tenants,
    Users,
    UserActivities,
    SupportEmailRequests,
    Close,
    Releases,
    InboxMessages,
    OutboxMessages,
    InternalOutboxMessages,
    EmailOutboxMessages,
    Data,
};
